import { render, staticRenderFns } from "./WrongRoute.vue?vue&type=template&id=9e5d2dc0&"
import script from "./WrongRoute.vue?vue&type=script&lang=js&"
export * from "./WrongRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports